export default __webpack_public_path__ + "static/media/gogo.7a3b0830.png";